import { isValidEmail } from 'utils/isValidEmail/isValidEmail';

export const validateEmail = (label: string) => (value: string) => (value && isValidEmail(value) ? undefined : label);
